import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const WishlistButton = ({ gameId, releaseDate }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;
  const navigate = useNavigate();

  const [added, setAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const isUnreleased = releaseDate > Math.floor(Date.now() / 1000);

  const handleClick = async () => {
    if (!userId) {
      navigate("/login");
      return;
    }

    if (added || loading) return;

    setLoading(true);
    try {
      await axios.post("/api/user-game-preferences", {
        user_id: userId,
        game_id: gameId,
        wishlist: 1,
        tracking: isUnreleased ? 1 : 0
      });
      setAdded(true);
    } catch (err) {
      console.error("Failed to add to wishlist:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={added || loading}
      className={`w-full py-2 px-4 rounded text-white transition-colors duration-200 ${
        added
          ? "bg-green-500 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
    >
      {added ? "Wishlisted" : loading ? "Adding..." : "Wishlist"}
    </button>
  );
};

export default WishlistButton;
